import { ISendSchedule } from "shared/types/SendSchedule";
import API from "shared/services/Api";
import { IPostClinicalRecordResponse } from "shared/types/ClinicalRecord";

export const sendSchedule = async (
  data: ISendSchedule
): Promise<IPostClinicalRecordResponse> => API.post("oc/clinicalrecord", data);
